import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Slider from '../../../components/Slider/Slider';
import ContentfulImage from '../../../components/ContentfulImage';
import Placeholder from '../../../components/Placeholder';
import Markdown from '../../../components/Markdown';

import {
  Section,
  Title,
  SliderWrapper,
  InstructorCell,
  ImageWrapper,
  TextContent,
  Name,
  Description,
} from './InstructorSlider.style';

const InstructorSlider = ({ instructors, copy }) => (
  <Section>
    <Title>{copy.instructors || <Placeholder h="20px" w="150px" />}</Title>
    <SliderWrapper>
      {instructors.length > 0 ? (
        <Slider
          dots
          keys={instructors.map(instructor => instructor.entryId)}
          options={{
            duration: 400,
            easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
            loop: true,
          }}
        >
          {instructors.map(instructor => (
            <InstructorCell key={instructor.entryId}>
              <ImageWrapper>
                <ContentfulImage
                  src={instructor.image}
                  options={{
                    size: [600, 900, 600, 720],
                    objectFit: 'cover',
                  }}
                />
              </ImageWrapper>

              <TextContent>
                <Name>{instructor.name}</Name>
                <Markdown src={instructor.description} Component={Description} />
              </TextContent>
            </InstructorCell>
          ))}
        </Slider>
      ) : (
        <Placeholder w="100%" pb="calc(100% / 3)" />
      )}
    </SliderWrapper>
  </Section>
);

InstructorSlider.defaultProps = {
  copy: {},
  instructors: null,
};

InstructorSlider.propTypes = {
  copy: PropTypes.shape(),
  instructors: PropTypes.arrayOf(PropTypes.shape({})),
};

const mapState = state => ({
  copy: state.siteOptions.siteCopySeminarPage,
});

export default connect(mapState)(InstructorSlider);



// WEBPACK FOOTER //
// ./src/pages/SeminarPage/InstructorSlider/InstructorSlider.js